export const authRoles = {
  sa: ['SA'],
  admin: ['SA', 'ADMIN'],
  secretaria: ['SA', 'ADMIN', 'SECRETARIA'],
  financeiro: ['SA', 'ADMIN', 'FINANCEIRO'],
  professor: ['SA', 'ADMIN', 'SECRETARIA', 'PROFESSOR']
}